import type { UninstallAppResponseType } from 'unified-auth-core-lib';
import {
  defaultRegistry,
  type AuthProviderKey,
  type AuthRegistry,
} from './registry';

export interface UninstallAppOptions {
  appId: number;
  providerKey?: AuthProviderKey;
  registry?: AuthRegistry;
}

export async function uninstallApp(
  options: UninstallAppOptions
): Promise<UninstallAppResponseType> {
  const { appId, providerKey, registry = defaultRegistry } = options;
  const components = await registry.resolveComponents(appId, providerKey);
  if (!components) {
    throw new Error(
      `[unified-auth] No auth provider found for appId: ${appId}`
    );
  }
  return components.uninstallApp(appId);
}
